<template>
  <div>
    <div class="p-8" v-if="loading">
      <loading />
    </div>
    <div class="p-6" v-else>
      <h2 class="mb-0 leading-tight">{{ activity.title }}</h2>
      <p class="tracking-wide">{{ user.username }} lädt dich ein</p>
      <div class="text-sm grid items-center justify-center border-t border-b mt-8 mb-4 py-4">
        <p class="text-4xl mr-2 text-center leading-none">{{ target.target }}x</p>
        <p class="italic">Bis {{ target.end | formatDate }}</p>
      </div>

      <div>
        <wd-button
          class="mr-2"
          css="border-red-500 text-red-500"
          @input="rejectInvitation"
        >{{ $t("targets.invitation.reject") }}</wd-button>
        <wd-button
          css="border-green-500 text-green-500"
          @input="acceptInvitation"
        >{{ $t("targets.invitation.accept") }}</wd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Target } from "@/modules/targets/viewmodels/Target";
import { Activity } from "@/modules/activities/viewmodels/Activity";

import FormMixin from "@/mixins/FormMixin";
import DateMixin from "@/mixins/DateMixin";
import moment from "moment";

export default {
  name: "TargetDetailSite",
  mixins: [DateMixin, FormMixin],
  data() {
    return {
      target: null,
      targetInvitation: null,
      activity: null,
      user: null
    };
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {},
  methods: {
    rejectInvitation() {
      this.submit({
        type: "targetinvitation",
        async: true,
        custom: true,
        call: "reject",
        id: this.id,
        action: () => {
          this.popup({
            type: "info",
            title: this.$t("targets.invitation.invitation_rejected"),
            text: this.$t("targets.invitation.invitation_rejected_message", {
              target: this.target.title
            }),
            autoHide: true
          });
          this.goTo("/targets");
        }
      });
    },
    acceptInvitation() {
      this.submit({
        type: "targetinvitation",
        async: true,
        custom: true,
        call: "accept",
        id: this.id,
        action: () => {
          this.popup({
            type: "info",
            title: this.$t("targets.invitation.invitation_accepted"),
            text: this.$t("targets.invitation.invitation_accepted_message", {
              target: this.target.title
            }),
            autoHide: true
          });
          this.goTo("/targets");
        }
      });
    }
  },
  computed: {},
  async created() {
    this.targetInvitation = await this.$store.getters[
      "targetinvitation/api"
    ].Show(this.id);
    this.target = await this.$store.getters["target/api"].Show(
      this.targetInvitation.target_id
    );
    this.activity = await this.$store.getters["activity/api"].Show(
      this.target.activity_id
    );
    this.user = await this.$store.getters["users/api"].Show(
      this.target.user_id
    );
    this.$store.dispatch("header/update", {
      elements: [
        {
          value: this.$t("targets.target_invitation"),
          css: "tracking-widest font-medium"
        }
      ],
      backbutton: true,
      clear: true
    });
    this.loaded();
  }
};
</script>
